import BaseDropdownInputView from './base';

export default class DropdownInputView extends BaseDropdownInputView {
  classNameIdentifier = 'custom-dropdown-renderer';
}
